<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpRow
    v-if="loaded"
  >
    <ItpCol
      col="7"
    >
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="8"
        name="name"
        :label="'Name'|pgettext('Company')"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormInput
          name="name"
          v-model="item.name"
          required
          autofocus
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        name="code"
        :label="'Code'|pgettext('Company')"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormInput
          name="number"
          v-model="item.code"
          required
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="5"
        name="account_type"
        :label="'Default'|gettext"
        :labelAlign="labelAlign"
      >
        <ItpFormCheckbox
          name="is_default"
          inline
          v-model="item.is_default"
          :readonly="item.isReadOnly"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="8"
        name="relation"
        :label="'Type'|pgettext('Company')"
        :labelAlign="labelAlign"
        required
        v-if="item.role === 'partner'"
      >
        <ItpFormSelect
          name="relation"
          v-model="item.relation"
          required
          :options="companyRelations"
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="8"
        name="groups"
        :label="'Groups'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormSelect2
          name="groups"
          v-model="item.groups"
          multiple
          :options="companyGroups"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="8"
        name="emails"
        :label="'Email'|pgettext('Company')"
        :labelAlign="labelAlign"
        :description="'Multiple email addresses should be separated by semicolon.'|pgettext('Company')"
      >
        <ItpFormInput
          type="text"
          name="emails"
          v-model="item.emails"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="8"
        name="external_key"
        :label="'External key'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormInput
          name="number"
          v-model="item.external_key"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <hr>
      </hr>
      <ItpFormGroup
        labelColsMd="4"
        contentColsMd="8"
        name="notes"
        :label="'Notes'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpCol>
    <ItpCol
      col="5"
    >
      <ItpAlert
        type="info"
        show
        class="offset-md-4"
        v-if="displayFetchByTaxNumber"
      >
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <span>
          {{ 'By providing the tax number, the company data can be directly retrieved from the NAV database.'|pgettext('Company') }}
        </span>
      </ItpAlert>
      <ItpFormGroup
        labelColsMd="4"
        name="tax_number"
        :label="'Tax number'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <DIV>
          <ItpFormInput
            name="tax_number"
            v-model="item.tax_number"
          >
          </ItpFormInput>
          <ItpButton
            variant="primary"
            :icon="$config.downloadIcon"
            :tooltip="'Fetch taxpayer data from NAV database'|pgettext('Company')"
            :disabled="!item.tax_number"
            :spinning="actions.fetchTaxpayer.isRunning"
            size="sm"
            :text="'Retrieve data'|pgettext('Company')"
            class="mt-3"
            v-if="displayFetchByTaxNumber && item.tax_number"
            @click.prevent.stop="evh_8497951412896552_clickPreventStop($event, {})"
          >
          </ItpButton>
        </DIV>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        name="tax_number"
        :label="'Tax number history'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormTextarea
          name="tax_number_history"
          v-model="item.tax_number_history"
          mode="list"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        name="group_member_tax_number"
        :label="'Group member tax number'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormInput
          name="group_member_tax_number"
          v-model="item.group_member_tax_number"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        name="eu_tax_number"
        :label="'EU tax number'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormInput
          name="eu_tax_number"
          v-model="item.eu_tax_number"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        labelColsMd="4"
        name="registration_number"
        :label="'Registration number'|pgettext('Company')"
        :labelAlign="labelAlign"
      >
        <ItpFormInput
          name="registration_number"
          v-model="item.registration_number"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <DIV
        v-if="isOwnCompany"
      >
        <hr>
        </hr>
        <ItpFormGroup
          labelColsMd="4"
          name="settings_send_invoice_notifications"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="send_invoice_notifications"
            :label="'Send invoice notifications'|pgettext('Company')"
            v-model="settings.send_invoice_notifications"
            @input="evh_2014513287668498_input($event, {})"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          contentColsMd="8"
          name="settings_smtp_mail_account_id"
          :labelAlign="labelAlign"
          :label="'SMTP Mail Account'|pgettext('Company')"
        >
          <UcMailAccountSelector
            name="smtp_mail_account_id"
            :item="settings"
            path="smtp_mail_account_id"
            clearable
            :bindObject="b_1490259005804208_bindObject"
            @input="evh_1490259005804208_input($event, {})"
          >
          </UcMailAccountSelector>
        </ItpFormGroup>
      </DIV>
      <DIV
        v-if="!isOwnCompany"
      >
        <hr>
        </hr>
        <ItpFormGroup
          name="payment_period_days"
          :label="'Payment period'|pgettext('Company')"
          labelColsMd="4"
          contentColsMd="5"
          :labelAlign="labelAlign"
          contentClass="input-group"
          v-if=""
        >
          <ItpFormInput
            type="number"
            name="payment_period_days"
            v-model="item.payment_period_days"
          >
          </ItpFormInput>
          <DIV
            class="input-group-append"
          >
            <span
              class="input-group-text"
            >
              {{ 'days'|pgettext('InputGroupAddon') }}
            </span>
          </DIV>
        </ItpFormGroup>
        <ItpFormGroup
          name="discount"
          :label="'Discount'|pgettext('Company')"
          labelColsMd="4"
          contentColsMd="4"
          :labelAlign="labelAlign"
          contentClass="input-group"
        >
          <ItpFormInput
            type="number"
            name="discount"
            v-model="item.discount"
          >
          </ItpFormInput>
          <DIV
            class="input-group-append"
          >
            <span
              class="input-group-text"
            >
              %
            </span>
          </DIV>
        </ItpFormGroup>
        <hr>
        </hr>
        <ItpFormGroup
          labelColsMd="4"
          name="is_contractor"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="is_contractor"
            :label="'Contractor'|pgettext('Company')"
            v-model="item.is_contractor"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          name="sole_proprietor"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="sole_proprietor"
            :label="'Sole proprietor'|pgettext('Company')"
            v-model="item.sole_proprietor"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          name="is_natural_person"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="is_natural_person"
            :label="'Natural person'|pgettext('Company')"
            v-model="item.is_natural_person"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          name="vat_exempt"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="vat_exempt"
            :label="'VAT exempt'|pgettext('Company')"
            v-model="item.vat_exempt"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          name="excluded_from_claims"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="excluded_from_claims"
            :label="'Exclude from claims'|pgettext('Company')"
            v-model="item.excluded_from_claims"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <hr>
        </hr>
        <ItpFormGroup
          labelColsMd="4"
          name="settings_notifications_enabled"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="settings__notifications_enabled"
            :label="'Notifications enabled'|pgettext('Company')"
            v-model="settings.notifications_enabled"
            @input="evh_5501809153536538_input($event, {})"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          name="settings_send_invoice_notifications"
          :labelAlign="labelAlign"
        >
          <ItpFormCheckbox
            name="settings__send_invoice_notifications"
            :label="'Send invoice notifications'|pgettext('Company')"
            v-model="settings.send_invoice_notifications"
            @input="evh_1014170467214631_input($event, {})"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="4"
          contentColsMd="8"
          name="settings__email_recipients"
          :label="'Email recipients'|pgettext('Company')"
          :labelAlign="labelAlign"
          :description="'Input one email address per row.'|pgettext('Company')"
        >
          <ItpFormTextarea
            type="text"
            name="settings__email_recipients"
            v-model="settings.email_recipients"
            mode="list"
            @input="evh_4664876391460503_input($event, {})"
          >
          </ItpFormTextarea>
        </ItpFormGroup>
      </DIV>
    </ItpCol>
  </ItpRow>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetCompanyGeneral extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  displayFetchByTaxNumber!: boolean;

  @Watch('displayFetchByTaxNumber')
  onDisplay_fetch_by_tax_number(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("displayFetchByTaxNumber")
  }

  companyRelations!: any;

  async $$load_companyRelations() {
    return this.$fn.getEnumValuesFromSchema('CompanyRelation', { sort: false })
  }

  companyGroups!: any;

  async $$load_companyGroups() {
    return this.$fn.fetch('list_group', { parameters: { type: 'company' } })
      .then(data => data.data.map(p => p.name))
  }

  defaultOwnCompanySettings!: any;
  defaultPartnerCompanySettings!: any;
  settings!: any;

  async $$load_settings() {
    return _.extend(
      {},
      this.item.role == 'own' ? this.$data.defaultOwnCompanySettings : this.$data.defaultPartnerCompanySettings,
      this.item.settings
    )
  }

  ux!: any;
  b_1490259005804208_bindObject!: any;
  dataMembers = ['companyRelations', 'companyGroups', 'defaultOwnCompanySettings', 'defaultPartnerCompanySettings', 'settings', 'ux', 'b_1490259005804208_bindObject'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        companyRelations: null,
        companyGroups: null,
        defaultOwnCompanySettings: {
          smtp_mail_account_id: null,
          send_invoice_notifications: false,
        }
        ,
        defaultPartnerCompanySettings: {
          notifications_enabled: null,
          email_recipients: [
          ]
          ,
          send_invoice_notifications: false,
        }
        ,
        settings: null,
        ux: null,
        b_1490259005804208_bindObject: false,
      },
    }
  }

  get isOwnCompany() {
    if (this.loaded) {

      return this.item.role === 'own'
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8497951412896552_emit_6724_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8497951412896552_emit_6724, alias=undefined
    return {
      event: "input",
      value: $event.data.response.data,
    }
  }

  async act_8497951412896552_request_6722_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8497951412896552_request_6722, alias=fetchTaxpayer
    return {
      operation: "read_company",
      data: {
        id: this.item.tax_number,
      }
      ,
      headers: {
        accept: "application/vnd.itp.taxpayer-info+json",
      }
      ,
    }
  }

  async evh_8497951412896552_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8497951412896552_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2014513287668498_script_6726_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2014513287668498_script_6726, alias=undefined
    this.item.settings = this.settings
  }

  async act_2014513287668498_script_6726_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2014513287668498_script_6726, alias=undefined
    return {
      value: () => this.act_2014513287668498_script_6726_getActionArgs_value($event),
    }
  }

  async evh_2014513287668498_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2014513287668498_input.executeFromDOM(this, event, scope);
  }

  async act_1490259005804208_script_6728_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1490259005804208_script_6728, alias=undefined
    this.item.settings = this.settings
  }

  async act_1490259005804208_script_6728_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1490259005804208_script_6728, alias=undefined
    return {
      value: () => this.act_1490259005804208_script_6728_getActionArgs_value($event),
    }
  }

  async evh_1490259005804208_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1490259005804208_input.executeFromDOM(this, event, scope);
  }

  async act_5501809153536538_script_6730_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5501809153536538_script_6730, alias=undefined
    this.item.settings = this.settings
  }

  async act_5501809153536538_script_6730_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5501809153536538_script_6730, alias=undefined
    return {
      value: () => this.act_5501809153536538_script_6730_getActionArgs_value($event),
    }
  }

  async evh_5501809153536538_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5501809153536538_input.executeFromDOM(this, event, scope);
  }

  async act_1014170467214631_script_6732_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1014170467214631_script_6732, alias=undefined
    this.item.settings = this.settings
  }

  async act_1014170467214631_script_6732_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1014170467214631_script_6732, alias=undefined
    return {
      value: () => this.act_1014170467214631_script_6732_getActionArgs_value($event),
    }
  }

  async evh_1014170467214631_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1014170467214631_input.executeFromDOM(this, event, scope);
  }

  async act_4664876391460503_script_6734_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4664876391460503_script_6734, alias=undefined
    this.item.settings = this.settings
  }

  async act_4664876391460503_script_6734_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4664876391460503_script_6734, alias=undefined
    return {
      value: () => this.act_4664876391460503_script_6734_getActionArgs_value($event),
    }
  }

  async evh_4664876391460503_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4664876391460503_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_6720: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_6719: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8497951412896552_emit_6724: actions.EmitAction;
    evh_8497951412896552_success_6723: actions.EventHandlerImpl;
    act_8497951412896552_request_6722: actions.RequestAction;
    evh_8497951412896552_clickPreventStop_6721: actions.EventHandlerImpl;
    evh_8497951412896552_clickPreventStop: actions.EventHandlerGroup;
    act_2014513287668498_script_6726: actions.ScriptAction;
    evh_2014513287668498_input_6725: actions.EventHandlerImpl;
    evh_2014513287668498_input: actions.EventHandlerGroup;
    act_1490259005804208_script_6728: actions.ScriptAction;
    evh_1490259005804208_input_6727: actions.EventHandlerImpl;
    evh_1490259005804208_input: actions.EventHandlerGroup;
    act_5501809153536538_script_6730: actions.ScriptAction;
    evh_5501809153536538_input_6729: actions.EventHandlerImpl;
    evh_5501809153536538_input: actions.EventHandlerGroup;
    act_1014170467214631_script_6732: actions.ScriptAction;
    evh_1014170467214631_input_6731: actions.EventHandlerImpl;
    evh_1014170467214631_input: actions.EventHandlerGroup;
    act_4664876391460503_script_6734: actions.ScriptAction;
    evh_4664876391460503_input_6733: actions.EventHandlerImpl;
    evh_4664876391460503_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_6720 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_6719 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_6720,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_6719],
      }
    );
    const act_8497951412896552_emit_6724 = new actions.EmitAction(
      {
        actionArgs: this.act_8497951412896552_emit_6724_getActionArgs,
        events: [],
      }
    );
    const evh_8497951412896552_success_6723 = new actions.EventHandlerImpl(
      {
        action: act_8497951412896552_emit_6724,
        event: "success",
        displayName: "emit",
      }
    );
    const act_8497951412896552_request_6722 = new actions.RequestAction(
      {
        actionArgs: this.act_8497951412896552_request_6722_getActionArgs,
        displayName: "fetchTaxpayer",
        events: [evh_8497951412896552_success_6723],
      }
    );
    const evh_8497951412896552_clickPreventStop_6721 = new actions.EventHandlerImpl(
      {
        action: act_8497951412896552_request_6722,
        event: "click.prevent.stop",
        displayName: "fetchTaxpayer",
      }
    );
    const evh_8497951412896552_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8497951412896552_clickPreventStop_6721],
      }
    );
    const act_2014513287668498_script_6726 = new actions.ScriptAction(
      {
        actionArgs: this.act_2014513287668498_script_6726_getActionArgs,
        events: [],
      }
    );
    const evh_2014513287668498_input_6725 = new actions.EventHandlerImpl(
      {
        action: act_2014513287668498_script_6726,
        event: "input",
        displayName: "script",
      }
    );
    const evh_2014513287668498_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_2014513287668498_input_6725],
      }
    );
    const act_1490259005804208_script_6728 = new actions.ScriptAction(
      {
        actionArgs: this.act_1490259005804208_script_6728_getActionArgs,
        events: [],
      }
    );
    const evh_1490259005804208_input_6727 = new actions.EventHandlerImpl(
      {
        action: act_1490259005804208_script_6728,
        event: "input",
        displayName: "script",
      }
    );
    const evh_1490259005804208_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_1490259005804208_input_6727],
      }
    );
    const act_5501809153536538_script_6730 = new actions.ScriptAction(
      {
        actionArgs: this.act_5501809153536538_script_6730_getActionArgs,
        events: [],
      }
    );
    const evh_5501809153536538_input_6729 = new actions.EventHandlerImpl(
      {
        action: act_5501809153536538_script_6730,
        event: "input",
        displayName: "script",
      }
    );
    const evh_5501809153536538_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5501809153536538_input_6729],
      }
    );
    const act_1014170467214631_script_6732 = new actions.ScriptAction(
      {
        actionArgs: this.act_1014170467214631_script_6732_getActionArgs,
        events: [],
      }
    );
    const evh_1014170467214631_input_6731 = new actions.EventHandlerImpl(
      {
        action: act_1014170467214631_script_6732,
        event: "input",
        displayName: "script",
      }
    );
    const evh_1014170467214631_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_1014170467214631_input_6731],
      }
    );
    const act_4664876391460503_script_6734 = new actions.ScriptAction(
      {
        actionArgs: this.act_4664876391460503_script_6734_getActionArgs,
        events: [],
      }
    );
    const evh_4664876391460503_input_6733 = new actions.EventHandlerImpl(
      {
        action: act_4664876391460503_script_6734,
        event: "input",
        displayName: "script",
      }
    );
    const evh_4664876391460503_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_4664876391460503_input_6733],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_6720,
      evh_7315092382398562_reload_6719,
      evh_7315092382398562_reload,
      act_8497951412896552_emit_6724,
      evh_8497951412896552_success_6723,
      act_8497951412896552_request_6722,
      evh_8497951412896552_clickPreventStop_6721,
      evh_8497951412896552_clickPreventStop,
      act_2014513287668498_script_6726,
      evh_2014513287668498_input_6725,
      evh_2014513287668498_input,
      act_1490259005804208_script_6728,
      evh_1490259005804208_input_6727,
      evh_1490259005804208_input,
      act_5501809153536538_script_6730,
      evh_5501809153536538_input_6729,
      evh_5501809153536538_input,
      act_1014170467214631_script_6732,
      evh_1014170467214631_input_6731,
      evh_1014170467214631_input,
      act_4664876391460503_script_6734,
      evh_4664876391460503_input_6733,
      evh_4664876391460503_input,
      fetchTaxpayer: act_8497951412896552_request_6722,
    }
  }
}

Vue.component("FieldsetCompanyGeneral", FieldsetCompanyGeneral);

</script>